"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var Hint_1 = require("./Hint");

var Position_1 = require("./Position");

var shape = prop_types_1.default.shape({
  from: Position_1.Position.shape.isRequired,
  hints: prop_types_1.default.arrayOf(Hint_1.Hint.shape).isRequired,
  to: Position_1.Position.shape.isRequired
});

function create(hints, from, to) {
  return {
    hints: hints,
    from: from,
    to: to
  };
}

function toCodeMirror(searchResult) {
  return {
    from: searchResult.from,
    list: searchResult.hints.map(Hint_1.Hint.toCodeMirror),
    to: searchResult.to
  };
}

exports.SearchResult = {
  create: create,
  shape: shape,
  toCodeMirror: toCodeMirror
};